<template>
  <div class="member">
    <navbar_staff />
    <div class="space"></div>
    <div class="container">
      <div class="tebs_content">
        <div class="tebs_floting">
          <div class="row">
            <div class="col-5">
              <div class="circle_content">
                <div class="circle_floting">
                  <div class="circle">
                    <span class="circle__btn">
                      <img
                        class="circle_img"
                        :src="require('@/assets/avatars/' + code + '.jpg')"
                        alt=""
                      />
                      <!-- <ion-icon class="pause" name="pause"></ion-icon>
                              <ion-icon class="play" name="play"></ion-icon> -->
                    </span>
                    <span class="circle__back-1"></span>
                    <span class="circle__back-2"></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-7">
              <br />
              <div class="segmented-control">
                <input
                  type="radio"
                  name="radio2"
                  v-model="radio_btn"
                  @change="onChange"
                  value=""
                  id="tab-1"
                  checked
                />
                <label for="tab-1" class="segmented-control__1">
                  <p>Pending</p></label
                >
                <input
                  type="radio"
                  name="radio2"
                  v-model="radio_btn"
                  @change="onChange"
                  value="members"
                  id="tab-2"
                />
                <label for="tab-2" class="segmented-control__2">
                  <p>Members</p>
                </label>

                <input
                  type="radio"
                  name="radio2"
                  v-model="radio_btn"
                  @change="onChange"
                  value="wait"
                  id="tab-3"
                />
                <label for="tab-3" class="segmented-control__3">
                  <p>Wait...</p>
                </label>

                <div class="segmented-control__color"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="space"></div>
      <br />
      <!-- ================================ Detail Tabs =============================================== -->
      <br />
      <!-- ================================ pending ================================================== -->
      <div class="pending" v-show="radio_btn === ''">
     
        <div class="card-columns">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-xs-12">
              <div class="card card-order-list calendar-border">
                <div class="card-body">
                  <img :src="img" width="100" height="100" />
                  <!-- <VueSignaturePad
                  id="signature"
                  width="100%"
                  height="300px"
                  ref="signaturePad"
                  :options="options"
                /> -->
              
                  <br />
                  <b-table
                    striped
                    hover
                    :items="items"
                    :fields="fields"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    responsive="sm"
                    class="text-left"
                  >
                    <template #cell(index)="data">
                      {{ data.index + 1 }}
                    </template>
                    <template #cell(name)="data">
                      {{ data.value }}
                    </template>
                    <template #cell(isActive)="data">
                      <!-- <button class="btn btn-info" v-if="data.value === true">ชำระเงิน</button> -->
                      <!-- <b-button
                      v-b-modal.modal-center
                        class="btn btn-info"
                        v-if="data.value === true"
                        >ชำระเงิน</b-button
                      > -->
                      <b-button
                        v-b-modal="'modal-center' + data.index"
                        class="btn btn-info"
                        v-if="data.value === true"
                        >ชำระเงิน</b-button
                      >
                      <button
                        class="btn btn-success"
                        v-if="data.value === false"
                      >
                        กำลังดำเนินการ
                      </button>
                      <!-- <button class="btn btn-info">{{data.value}}</button> -->
                     
                      <b-modal
                        :id="'modal-center' + data.index"
                        centered
                        title="BootstrapVue"
                        size="lg"
                      >
                    
                        <!-- <p class="my-4">{{ data.index }}</p> -->
                        <div class="card card-order-list calendar-border">
                          <div class="container">
                            <VueSignaturePad
                            id="signature"
                            width="100%"
                            height="300px"
                            ref="signaturePad"
                            :options="options"
                          />
                          </div>
                           
                        
                          <div class="card-body">
                            <!-- <div class="container"> -->
                              <!-- {{ img}} -->
                             
                            <!-- </div> -->
                            <div class="buttons">
                              <button @click="undo">Undo</button>
                              <button @click="save">Save</button>
                              <button @click="change">Change Color</button>
                              <button @click="resume">Resume Color</button>
                            </div>
                          </div>
                          <!-- <VueSignaturePad ref="signaturePad" />
                          <div>
                            <button @click="save">Save</button>
                            <button @click="undo">Undo</button>
                          </div> -->
                          <!-- <div class="card-body">
                            <img :src="`${img}`" />
                          </div> -->
                          <!-- :defaultUrl="dataUrl" -->
                          <!-- <div class="card-body">
                            <vueSignature i vue-signature-pad
                              ref="signature"
                              :sigOption="option"
                              :w="'400px'"
                              :h="'400px'"
                              :disabled="disabled"
                            ></vueSignature>
                          </div> -->

                          <!-- <vueSignature ref="signature1" :sigOption="option"></vueSignature> -->
                          <!-- <button @click="save">Save</button>
                          <button @click="clear">Clear</button> -->
                          <!-- <button @click="undo">Undo</button>
                          <button @click="addWaterMark">addWaterMark</button>
                          <button @click="handleDisabled">disabled</button> -->
                        </div>
                      </b-modal>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ================================ END pending ============================================== -->
      <!-- ================================  Members ================================================= -->
      <div class="members" v-show="radio_btn === 'members'">
        <div class="card-columns">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-xs-12">
              <div class="card card-order-list calendar-border">
                <div class="card-body">
                  <br />
                  <b-table
                    striped
                    hover
                    :items="items"
                    :fields="fields"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    responsive="sm"
                    class="text-left"
                  >
                    <template #cell(index)="data">
                      {{ data.index + 1 }}
                    </template>
                    <template #cell(name)="data">
                      {{ data.value }}
                    </template>
                    <template #cell(isActive)="data">
                      <button
                        class="btn btn-success"
                        v-if="data.value === true"
                      >
                        เป็นสมาชิกแล้ว
                      </button>
                      <button
                        class="btn btn-secondary"
                        v-if="data.value === false"
                      >
                        หมดอายุ
                      </button>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ================================ END Members ============================================== -->
    </div>
  </div>
</template>

<script>
import navbar_staff from "../layouts/navbar_staff.vue";
import { VueSignaturePad } from "vue-signature-pad";
// import vueSignature from "vue-signature";
// import axios from "axios";
// import { VueGoodTable } from 'vue-good-table';
// import $ from "jquery";
export default {
  name: "member",
  components: { navbar_staff, VueSignaturePad },
  data() {
    return {
      token: "dQpojB8WkH7HAZdh223jaqFSB1x5RYoKBjU0BAaVZt8DTVaxO5Sx5DlsErA2Zsu",
      code: "",
      radio_btn: "",
      options: {
        penColor: "#c0f",
      },
      dataUrl: "",
      disabled: false,
      sortBy: "age",
      sortDesc: false,
      img: "",
      fields: [
        { key: "index", label: "ลำดับ", sortable: false },
        { key: "name", label: "Full Name", formatter: "fullName" },
        { key: "age", label: "อายุ", sortable: false },
        { key: "phone", label: "เบอร์โทร", sortable: false },
        { key: "month", label: "วันที่สมัคร", sortable: false },
        { key: "exp", label: "วันหมดอายุ", sortable: false },
        { key: "price", label: "ค่าบริการ", sortable: false },
        { key: "isActive", label: "สถานะ", sortable: false },
      ],
      items: [
        {
          isActive: true,
          age: 40,
          name: { first: "John", last: "Doe" },
          phone: "0987654321",
          month: "12/05/2024",
          exp: "12/05/2024",
          price: 500,
        },
        {
          isActive: false,
          age: 21,
          name: { first: "Larsen", last: "Shaw" },
          phone: "0987654321",
          month: "24/03/2024",
          price: 500,
        },
        {
          isActive: false,
          age: 89,
          name: { first: "Geneva", last: "Wilson" },
          phone: "0987654321",
          month: "10/05/2024",
          price: 500,
        },
        {
          isActive: true,
          age: 38,
          name: { first: "Jami", last: "Carney" },
          phone: "0987654321",
          month: "03/01/2024",
          price: 500,
        },
      ],
    };
  },
  mounted() {
    if (localStorage.getItem("auth") != null) {
      let c = JSON.parse(localStorage.getItem("auth"));
      this.code = c.std_code;
    }
    // this.gethistory();
  },
  methods: {
    onChange() {
      // console.log(this.radio_btn);
    },
    fullName(value) {
      return `${value.first} ${value.last}`;
    },
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

      // alert("Open DevTools see the save data.");
      console.log(isEmpty);
      console.log(data);
      this.img = data;
    },
    change() {
      this.options = {
        penColor: "#00f",
      };
    },
    resume() {
      this.options = {
        penColor: "#c0f",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.space {
  height: 100px;
}
.member {
  background: var(--greyLight-1) no-repeat center center;
  background-size: cover;
  min-height: 100vh;
  position: absolute;
  width: 100%;
}
#signature {
  border: double 3px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box;
}

.container {
  width: "100%";
  padding: 8px 16px;
}

.buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-top: 8px;
}

/*  Avatar BUTTON  */
.circle_content {
  position: relative;
}
.circle_img {
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.circle_floting {
  position: absolute;
  top: -10px;
  left: -22px;
  font-size: 14px;
}
.circle {
  grid-column: 2/3;
  grid-row: 4/6;
  width: 8rem;
  height: 100%;
  justify-self: center;
  border-radius: 1rem;
  display: grid;
  grid-template-rows: 1fr;
  justify-items: center;
  align-items: center;
}
.circle__btn {
  grid-row: 1/2;
  grid-column: 1/2;
  width: 9rem;
  height: 6rem;
  display: flex;
  margin: 0.6rem;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 3.2rem;
  color: var(--primary);
  z-index: 300;
  background: var(--greyLight-1);
  box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2),
    -0.2rem -0.2rem 0.5rem var(--white);
  cursor: pointer;
  position: relative;
}
.circle__btn.shadow {
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
}
.circle__btn .play {
  position: absolute;
  opacity: 0;
  transition: all 0.2s linear;
}
.circle__btn .play.visibility {
  opacity: 1;
}
.circle__btn .pause {
  position: absolute;
  transition: all 0.2s linear;
}
.circle__btn .pause.visibility {
  opacity: 0;
}
.circle__back-1,
.circle__back-2 {
  grid-row: 1/2;
  grid-column: 1/2;
  width: 6rem;
  height: 6rem;
  border-radius: 50%;
  filter: blur(1px);
  z-index: 100;
}
.circle__back-1 {
  box-shadow: 0.4rem 0.4rem 0.8rem var(--greyLight-3),
    -0.4rem -0.4rem 0.8rem var(--white);
  background: linear-gradient(
    to bottom right,
    var(--greyLight-3) 0%,
    var(--white) 100%
  );
  -webkit-animation: waves 4s linear infinite;
  animation: waves 4s linear infinite;
}
.circle__back-1.paused {
  -webkit-animation-play-state: paused;
  animation-play-state: paused;
}
.circle__back-2 {
  box-shadow: 0.4rem 0.4rem 0.8rem var(--greyLight-3),
    -0.4rem -0.4rem 0.8rem var(--white);
  -webkit-animation: waves 4s linear 2s infinite;
  animation: waves 4s linear 2s infinite;
}
.circle__back-2.paused {
  -webkit-animation-play-state: paused;
  animation-play-state: paused;
}

@-webkit-keyframes waves {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}

@keyframes waves {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}
/*END */
/* tebs content */
.tebs_content {
  position: relative;
}
.tebs_floting {
  position: absolute;
  top: 0px;
  left: 0px;
  font-size: 14px;
}

.segmented-control {
  grid-column: 3/4;
  grid-row: 1/2;
  width: 19.5rem;
  height: 3.4rem;
  box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2),
    -0.2rem -0.2rem 0.5rem var(--white);
  border-radius: 1rem;
  display: flex;
  align-items: center;
  position: relative;
}
.segmented-control input {
  display: none;
}
.segmented-control > input:checked + label {
  transition: all 0.5s ease;
  color: rgb(209, 95, 2);
}
.segmented-control__1,
.segmented-control__2,
.segmented-control__3 {
  width: 6.3rem;
  height: 3.6rem;
  font-size: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #ff5f2d;
  transition: all 0.5s ease;
  margin-top: 1.5rem;
}
.segmented-control__1:hover,
.segmented-control__2:hover,
.segmented-control__3:hover {
  color: rgb(209, 95, 2);
}
.segmented-control__color {
  position: absolute;
  height: 2.5rem;
  width: 6.6rem;
  margin-left: 0.3rem;
  border-radius: 0.8rem;
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
  pointer-events: none;
}

#tab-1:checked ~ .segmented-control__color {
  transform: translateX(0);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

#tab-2:checked ~ .segmented-control__color {
  transform: translateX(6rem);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

#tab-3:checked ~ .segmented-control__color {
  transform: translateX(12.2rem);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
/* end*/

/* Card */
.card-header:first-child {
  /* border-radius: 0px; */
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}
.card-columns .card {
  border-radius: 20px;
}
.card-columns {
  column-count: 1;
}
.card-columns-two {
  column-count: 2;
}
.calendar-border {
  border: none;
  background-color: var(--greyLight-1);
  border-radius: 2rem;
  box-shadow: 0.8rem 0.8rem 1.4rem var(--greyLight-2),
    -0.2rem -0.2rem 1.8rem var(--white);
}
.shadow-date {
  border-radius: 2rem;
  box-shadow: 0.8rem 0.8rem 1.4rem var(--greyLight-2),
    -0.2rem -0.2rem 1.8rem var(--white);
}
.card-title {
  text-align: left;
  text-align: justify;
  bottom: 10px;
}
.card-text {
  text-align: left;
  line-height: 23px;
  margin-bottom: -5px;
}
.text-muted i {
  margin: 0 5px;
}
/* */
</style>
